import { render, staticRenderFns } from "./StudentAward.vue?vue&type=template&id=0a5ba60d&"
import script from "./StudentAward.vue?vue&type=script&lang=js&"
export * from "./StudentAward.vue?vue&type=script&lang=js&"
import style0 from "./StudentAward.vue?vue&type=style&index=0&id=0a5ba60d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports